module.exports = __webpack_public_path__ + "img/register.ec80648f.png";